import React,{useRef,useEffect, useContext} from 'react';
import { NavIconContext } from '../../../context/NavIconContext';
import styles from './noti.module.css'

export const NotificationItem=(props)=>{
    return(
        <div className={styles.notiItem}>


          
            <img className={styles.userpp} src={props.ppurl}/>
            <div className={styles.mainCon}>
                <div className={styles.notihead}>{props.text}</div>
                <div className={styles.notitime}>{props.time}</div>
            </div>
            {props.mediaurl?
            <img className={styles.thummailimg} src={props.mediaurl}/>:""}
        </div>
    )
}












const Notifications=()=>{

    const node = useRef();
    const {setNotificationShow}=useContext(NavIconContext);

    const handleClick = e => {
        if (node.current.contains(e.target)) {
          // inside click
          
          return;
        }
        setNotificationShow(false)
        // outside click 
        // ... do whatever on click outside here ...
      };

    useEffect(() => {
        // add when mounted
        document.addEventListener("mousedown", handleClick);
        // return function to be called when unmounted
        return () => {
          document.removeEventListener("mousedown", handleClick);
        };
      }, []);




    
    return(
        <div ref={node} >
                <div className={styles.Contianer}>
        <div className={styles.head}>
        <h3>Notifications</h3>
        </div>
        <div className={styles.scoll}>
       
       <NotificationItem
       ppurl="https://st3.depositphotos.com/6903990/15245/i/600/depositphotos_152459820-stock-photo-beautiful-girl-with-long-wavy.jpg"
       text="arham Choudhary Liked your photo"
       time="1 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
       <NotificationItem
       ppurl="https://st3.depositphotos.com/6903990/15245/i/600/depositphotos_152459820-stock-photo-beautiful-girl-with-long-wavy.jpg"
       text='arham Choudhary comment on your photo "Beatifull Click ❤️!"'
       time="1 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
        <NotificationItem
       ppurl="https://vsam.me/userimages/02-54-42-28-12-20.png"
       text='mini_001 comment on your photo "lovely pic 😘"'
       time="3 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
       <NotificationItem
       ppurl="https://vsam.me/userimages/113-01-01-21-10-56-11-1-01-21.png"
       text='jhondeo Liked your photo'
       time="3 hours ago"
       mediaurl="https://vsam.me/userimages/132-03-01-21-06-14-24-3-01-21.png"

       />
        <NotificationItem
       ppurl="https://vsam.me/userimages/113-01-01-21-10-56-11-1-01-21.png"
       text='jhondeo started following you"'
       time="4 hours ago"
       />
        <NotificationItem
       ppurl="https://st3.depositphotos.com/6903990/15245/i/600/depositphotos_152459820-stock-photo-beautiful-girl-with-long-wavy.jpg"
       text="arham Choudhary Liked your photo"
       time="1 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
       <NotificationItem
       ppurl="https://st3.depositphotos.com/6903990/15245/i/600/depositphotos_152459820-stock-photo-beautiful-girl-with-long-wavy.jpg"
       text='arham Choudhary comment on your photo "Beatifull Click ❤️!"'
       time="1 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
        <NotificationItem
       ppurl="https://vsam.me/userimages/02-54-42-28-12-20.png"
       text='mini_001 comment on your photo "lovely pic 😘"'
       time="3 hours ago"
       mediaurl="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRICHgDuW1OZSSCrJg5UhA93eW3RNiqWIn_dg&usqp=CAU"
       />
       <NotificationItem
       ppurl="https://vsam.me/userimages/113-01-01-21-10-56-11-1-01-21.png"
       text='jhondeo Liked your photo'
       time="3 hours ago"
       mediaurl="https://vsam.me/userimages/132-03-01-21-06-14-24-3-01-21.png"

       />
        <NotificationItem
       ppurl="https://vsam.me/userimages/113-01-01-21-10-56-11-1-01-21.png"
       text='jhondeo started following you"'
       time="4 hours ago"
       />
      
</div>        
    </div>
    </div>)
}

export default Notifications